export default "__VITE_ASSET__DmrWsO8n__"